import gql from 'graphql-tag';

const DriverAssignment = gql(/* GraphQL */ `
  query DriverAssignment($id: ID!) {
    driverAssignment: dmDriverAssignment(id: $id) {
      id
      delivery {
        id
        orderNumber
        eventAt
        deliverySetup
        distanceInMiles
        durationInMinutes
        driverAskFor
        pickupAddress {
          id
          instructions
          locationName
          street1
          street2
          city
          state
          zip
        }
        dropoffAddress {
          id
          locationName
          street1
          street2
          city
          state
          zip
          phone
          instructions
        }
        dropoffWindow {
          endAt
          startAt
        }
        order {
          orderItems {
            name
            quantity
          }
        }
        status
      }
      feedback {
        message
      }
    }
  }
`);

export default DriverAssignment;
